<template>
    <div style="align-items: center; justify-content: center;">
       
        <div style="display: flex; align-items: center; justify-content: center;">
          <i 
            class="fa-solid fa-calendar-plus icon-margin" 
            style="margin-left: 8px; font-size: 50px;"
            :style="{ 'color': 'var(--cor-principal)'}">
          </i>
        </div>
        <div style="display: flex; align-items: center; justify-content: center;">
          <h6 
            class="px-3 py-3 custom-heading" 
            style="font-weight: bold;"
            :style="{ 'color': 'var(--cor-principal)'}">
            Sem agendamentos</h6>
        </div>
        <div style="text-align: center;">
          <span class="mt-0 mb-0" style="display: block;" :style="{ 'color': 'var(--cor-principal)'}"><small>Faça um novo agendamento clicando no</small></span>
          <span class="mt-0 mb-0" style="display: block;" :style="{ 'color': 'var(--cor-principal)'}"><small>botão "Agendar consulta" ou clique na aba</small></span>
          <span class="mt-0 mb-0" style="display: block;" :style="{ 'color': 'var(--cor-principal)'}"><small>"Histórico de atendimentos" para ver</small></span>
          <span class="mt-0 mb-0" style="display: block;" :style="{ 'color': 'var(--cor-principal)'}"><small>agendamentos já realizados.</small></span>
        </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "SemAgendamentos",
    props: {
      item: Object,
      index: Number,
      data: String 
    }
  };
  </script>
  
  <style scoped>
  </style>
  